import { render, staticRenderFns } from "./ReceiveChequeList.vue?vue&type=template&id=c2b97eb2&"
import script from "./ReceiveChequeList.vue?vue&type=script&lang=js&"
export * from "./ReceiveChequeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports